module.exports = __webpack_public_path__ + "clipboard.png?29399349f97f3db1fa6cd69d1c5e5504";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/temp/clipboard.png
// module id = 28
// module chunks = 0